<template>
  <div class="content">
    <el-dialog v-bind="$attrs" v-on="$listeners" @open="onOpen" title="编辑">
      <el-row :gutter="15">
        <el-form
          ref="modifyRef"
          :model="userInfo"
          :rules="rules"
          size="medium"
          label-width="100px"
        >
        <el-col :span="8">
            <el-form-item label="姓名" prop="userName">
              <el-input
                v-model="userInfo.userName"
                clearable
                :style="{ width: '100%' }"
              >
              </el-input>
            </el-form-item>
          </el-col>
          <el-col :span="8">
            <el-form-item label="用户名" prop="name">
              <el-input
                v-model="userInfo.name"
                clearable
                :style="{ width: '100%' }"
              >
              </el-input>
            </el-form-item>
          </el-col>
          <el-col :span="8">
            <el-form-item label="手机号码" prop="mobile">
              <el-input
                v-model="userInfo.mobile"
                clearable
                :style="{ width: '100%' }"
              >
              </el-input>
            </el-form-item>
          </el-col>
          <el-col :span="8">
            <el-form-item label="身份证号码" prop="idNo">
              <el-input
                v-model="userInfo.idNo"
                :disabled="true"
                clearable
                :style="{ width: '100%' }"
              >
              </el-input>
            </el-form-item>
          </el-col>
          <el-col :span="8">
            <el-form-item label="启用状态" prop="enableState">
              <el-select
                v-model="userInfo.enableState"
                placeholder="请选择启用状态"
                @change="handleChange"
              >
                <el-option
                  v-for="element in enableStateList"
                  :key="element.id"
                  :label="element.type"
                  :value="element.id"
                ></el-option>
              </el-select>
            </el-form-item>
          </el-col>
          <el-col :span="8">
            <el-form-item label="部门ID" prop="departmentId">
              <el-input
                v-model="userInfo.departmentId"
                :disabled="true"
                clearable
                :style="{ width: '100%' }"
              >
              </el-input>
            </el-form-item>
          </el-col>
          <el-col :span="8">
            <el-form-item label="部门名称" prop="departmentName">
              <el-input
                v-model="userInfo.departmentName"
                clearable
                :style="{ width: '100%' }"
              >
              </el-input>
            </el-form-item>
          </el-col>
          <el-col :span="8">
            <el-form-item label="聘用形式" prop="formOfEmployment">
              <el-select
                v-model="userInfo.formOfEmployment"
                placeholder="请选择聘用形式"
                @change="handleChange"
              >
                <el-option
                  v-for="element in formOfEmploymentList"
                  :key="element.id"
                  :label="element.type"
                  :value="element.id"
                ></el-option>
              </el-select>
            </el-form-item>
          </el-col>
          <el-col :span="8">
            <el-form-item label="工号" prop="workNumber">
              <el-input
                v-model="userInfo.workNumber"
                clearable
                :style="{ width: '100%' }"
              >
              </el-input>
            </el-form-item>
          </el-col>
          <el-col :span="8">
            <el-form-item label="管理形式" prop="formOfManagement">
              <el-select
                v-model="userInfo.formOfManagement"
                placeholder="请选择管理形式"
                @change="handleChange"
              >
                <el-option
                  v-for="element in formOfManagementList"
                  :key="element.id"
                  :label="element.type"
                  :value="element.id"
                ></el-option>
              </el-select>
            </el-form-item>
          </el-col>
          <el-col :span="8">
            <el-form-item label="年龄" prop="age">
              <el-input
                v-model="userInfo.age"
                clearable
                :style="{ width: '100%' }"
              >
              </el-input>
            </el-form-item>
          </el-col>
          <el-col :span="8">
            <el-form-item label="性别" prop="sex">
              <el-select
                v-model="userInfo.sex"
                placeholder="请选择性别"
                @change="handleChange"
              >
                <el-option
                  v-for="element in sexList"
                  :key="element.id"
                  :label="element.type"
                  :value="element.id"
                ></el-option>
              </el-select>
            </el-form-item>
          </el-col>
          <el-col :span="8">
            <el-form-item label="出生日期" prop="birthDate">
              <el-date-picker
                type="date"
                placeholder="选择出生日期"
                v-model="userInfo.birthDate"
                style="width: 100%"
              ></el-date-picker>
            </el-form-item>
          </el-col>
          <el-col :span="8">
            <el-form-item label="入职时间" prop="timeOfEntry">
              <el-date-picker
                type="date"
                placeholder="选择入职时间"
                v-model="userInfo.timeOfEntry"
                style="width: 100%"
              ></el-date-picker>
            </el-form-item>
          </el-col>
          <el-col :span="8">
            <el-form-item label="公司ID" prop="companyId">
              <el-input
                v-model="userInfo.companyId"
                clearable
                :style="{ width: '100%' }"
              >
              </el-input>
            </el-form-item>
          </el-col>
          <el-col :span="8">
            <el-form-item label="公司名称" prop="companyName">
              <el-input
                v-model="userInfo.companyName"
                clearable
                :style="{ width: '100%' }"
              >
              </el-input>
            </el-form-item>
          </el-col>
          <el-col :span="8">
            <el-form-item label="工作城市" prop="workingCity">
              <el-select
                v-model="userInfo.workingCity"
                placeholder="请选择工作城市"
                @change="handleChange"
              >
                <el-option
                  v-for="element in workingCityList"
                  :key="element.id"
                  :label="element.type"
                  :value="element.id"
                ></el-option>
              </el-select>
            </el-form-item>
          </el-col>
          <el-col :span="8">
            <el-form-item label="转正时间" prop="correctionTime">
              <el-date-picker
                type="date"
                placeholder="选择转正时间"
                v-model="userInfo.correctionTime"
                style="width: 100%"
              ></el-date-picker>
            </el-form-item>
          </el-col>
          <el-col :span="8">
            <el-form-item label="在职状态" prop="inServiceStatus">
              <el-select
                v-model="userInfo.inServiceStatus"
                placeholder="请选择在职状态"
                @change="handleChange"
              >
                <el-option
                  v-for="element in inServiceStatusList"
                  :key="element.id"
                  :label="element.type"
                  :value="element.id"
                ></el-option>
              </el-select>
            </el-form-item>
          </el-col>
          <el-col :span="8">
            <el-form-item label="等级" prop="level">
              <el-select
                v-model="userInfo.level"
                placeholder="请选择等级"
                @change="handleChange"
              >
                <el-option
                  v-for="element in levelList"
                  :key="element.id"
                  :label="element.type"
                  :value="element.id"
                ></el-option>
              </el-select>
            </el-form-item>
          </el-col>
          <el-col :span="8">
            <el-form-item label="备注" prop="mask">
              <el-input
                v-model="userInfo.mask"
                clearable
                :style="{ width: '100%' }"
              >
              </el-input>
            </el-form-item>
          </el-col>
        </el-form>
      </el-row>
      <div slot="footer" v-if="true">
        <el-button @click="close">取消</el-button>
        <el-button type="primary" @click="handelConfirm">确定</el-button>
      </div>
    </el-dialog>
  </div>
</template>
<script>
// import { modify, modifySubList } from "@/api/erModel/roleManagementEr";
// import { getAllSystem } from "@/api/dataModel/appSystem";
import { userModify,}  from '@/api/systemData'
export default {
  inheritAttrs: false,
  props: ["data"],
  data() {
    return {
      userInfo: {
        id:"",  
        userName:"",  //姓名
        name: "",  //用户名
        password: "",  //密码
        mobile: "",  //手机号码
        idNo: "",  //身份证号码
        enableState: "",  //启用状态 0禁用，1启用
        departmentId: "",  //部门ID
        departmentName: "",  //部门名称
        formOfEmployment: "",  //聘用形式
        workNumber: "",  //工号
        formOfManagement: "",  //管理形式
        age: "",  //年龄
        sex: "",  //性别 1男性，0女性
        birthDate: "",  //出生日期
        timeOfEntry: "",  //入职时间
        companyId: "",  //公司ID
        companyName: "",  //公司名称
        workingCity: "",  //工作城市
        correctionTime: "",  //转正时间
        inServiceStatus: "",  //在职状态 1.在职  2.离职
        createUser: "",  //创建人
        createDate: "",  //创建时间
        updateUser: "",  //修改人
        updateDate: "",  //修改日期
        level: "",  //等级
        mask: "",  //备注
      },
      otherForm: {
        roleAppSystemRelForm: {
          id: "",
          idList: [],
        },
      },
      allAppList: [],
      enableStateList:[
        { id: 1, type: "启用" },
        { id: 2, type: "禁用" },
      ],
      formOfEmploymentList:[
        { id: 1, type: "市场招聘" },
        { id: 2, type: "内部推荐" },
      ],
      formOfManagementList:[
        { id: 1, type: "总部直管" },
        { id: 2, type: "分企直管" },
      ],
      sexList:[
        { id: 1, type: "男" },
        { id: 2, type: "女" },
      ],
      workingCityList:[
        { id: 1, type: "北京" },
        { id: 2, type: "上海" },
      ],
      inServiceStatusList:[
        { id: 1, type: "在职" },
        { id: 2, type: "离职" },
      ],
      levelList:[
        { id: 1, type: "高级" },
        { id: 2, type: "普通" },
      ],
      rules: {
        name: [
          {
            required: true,
            message: "角色名称不能为空",
            trigger: "blur",
          },
        ],
        code: [
          {
            required: true,
            message: "角色编码不能为空",
            trigger: "blur",
          },
        ],
        description: [
          {
            required: true,
            message: "角色描述不能为空",
            trigger: "blur",
          },
        ],
        companyId: [
          {
            required: true,
            message: "所属企业不能为空",
            trigger: "blur",
          },
        ],
      },
      appSystemNameOptions: [],
    };
  },
  computed: {},
  watch: {
    data: {
      deep: true,
      handler(newData) {
        let newValue = {
          ...newData,
        };
        this.userInfo = newValue;
      },
    },
  },
  created() {
    // this.getAppSystemNameOptions()
  },
  mounted() {},
  methods: {
    handleChange(value){
      console.log("handleChange-value",value);
    },
    getAppSys() {
      getAllSystem().then((res) => {
        if (res.code == 0) {
          this.allAppList = res.data;
        }
      });
    },
    onOpen() {},
    onClose() {
      this.$refs["modifyRef"].resetFields();
    },
    close() {
      this.$emit("update:visible", false);
    },
    handelConfirm() {
      this.$refs["modifyRef"].validate((valid) => {
        if (valid) {
          userModify(this.userInfo).then((res) => {
            if (res.code == 10000) {
              let data = res.data;
              this.close();
              this.$emit("edit-success");
              // this.otherForm.roleAppSystemRelForm.id = data.id;
              // modifySubList(this.otherForm).then((res) => {
              //   if (res.code == 0) {
              //     this.$message.success("编辑成功");
              //     Object.keys(this.userInfo).forEach(
              //       (key) => (this.userInfo[key] = "")
              //     );
              //     Object.keys(this.otherForm).forEach(
              //       (key) => (this.otherForm[key] = "")
              //     );
              //     this.close();
              //     this.$emit("edit-success");
              //   }
              // });
            }
          });
        }
      });
    },
    getAppSystemNameOptions() {
      // 注意：this.$axios是通过Vue.prototype.$axios = axios挂载产生的
      this.$axios({
        method: "get",
        url: "/api/yys/appSystem/getAll",
      }).then((resp) => {
        let { data } = resp;
        let list = data.data;
        const newOptions = list.map((item) => {
          return {
            value: item["id"],
            label: item["appSystemName"],
          };
        });
        this.appSystemNameOptions = newOptions;
        // this.appSystemNameOptions = data.undefined
      });
    },
  },
};
</script>
<style>
.content {
  background-color: #fff;
  padding: 10px;
}
</style>
